/* ============================================================
   cb-shipping.js - Verzendinformatie (redesign 2026)

   Hoort bij sections/cb-shipping.liquid. Twee taken:

   1. De bestemmingspillen als tabs laten werken. Zonder dit script
      staan alle panelen open; het script verbergt ze pas als het
      draait. Zo blijven de tarieven van élke bestemming leesbaar als
      JavaScript uitvalt, in plaats van dat er niets staat.
   2. De track en trace-code aan de vervoerder-URL plakken. Het
      formulier is een gewone GET, dus zonder script komt de bezoeker
      op de trackpagina van PostNL uit met de code als parameter, wat
      ook werkt; met script wordt het het nettere pad-formaat.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-cb-ship]');
  if (!root) return;

  /* ---- 1. Bestemmingen ---- */

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cb-ship-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cb-ship-panel]'));

  function select(code) {
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-cb-ship-tab') === code;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      /* Alleen de actieve tab in de tabvolgorde, zoals het hoort bij tabs. */
      tab.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-cb-ship-panel') !== code;
    });
  }

  if (tabs.length && panels.length) {
    select(tabs[0].getAttribute('data-cb-ship-tab'));

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        select(tab.getAttribute('data-cb-ship-tab'));
      });

      /* Pijltjes horen bij een tablist. */
      tab.addEventListener('keydown', function (event) {
        var step = 0;
        if (event.key === 'ArrowRight') step = 1;
        if (event.key === 'ArrowLeft') step = -1;
        if (!step) return;
        event.preventDefault();
        var next = tabs[(index + step + tabs.length) % tabs.length];
        next.focus();
        select(next.getAttribute('data-cb-ship-tab'));
      });
    });
  }

  /* ---- 2. Track en trace ---- */

  var form = root.querySelector('[data-cb-ship-track]');
  if (!form) return;

  form.addEventListener('submit', function (event) {
    var field = form.querySelector('input[name="code"]');
    var code = field ? field.value.trim() : '';
    if (!code) return;

    var base = form.getAttribute('action') || '';
    if (base.slice(-1) !== '/') base += '/';

    event.preventDefault();
    window.open(base + encodeURIComponent(code), '_blank', 'noopener');
  });
})();
